import { type ReactNode } from 'react';
import { QueryProvider } from './QueryProvider';
import { MsalProvider } from '@/providers';

interface AppProviderProps {
  children: ReactNode;
}

export function AppProvider({ children }: AppProviderProps) {
  return (
    <MsalProvider>
      <QueryProvider>{children}</QueryProvider>
    </MsalProvider>
  );
}
